module.exports = __webpack_public_path__ + "static/media/arbol.2b8d4271.png";